/** **** Section View Event Handling ******/

// This is then function used to detect if the element is scrolled into view
function isScrolledIntoView(el) {
    const rect = el.getBoundingClientRect();
    const elemTop = rect.top;
    const elemBottom = rect.bottom;
    // Partially visible elements return true:
    return elemTop < window.innerHeight && elemBottom >= 0;
}

// Functions to stop page scroll when dialog for section 8 is active
const keys = {37: 1, 38: 1, 39: 1, 40: 1}

function preventDefault(e) {
  e.preventDefault();
}

function preventDefaultForScrollKeys(e) {
  if (keys[e.keyCode]) {
    preventDefault(e);
    return false;
  }
}

let supportsPassive = false

try {
  window.addEventListener("test", null, Object.defineProperty({}, 'passive', {
    get: function () { supportsPassive = true; }
  }));
} catch(e) {}

let wheelOpt = supportsPassive ? { passive: false } : false
let wheelEvent = 'onwheel' in document.createElement('div') ? 'wheel' : 'mousewheel'

function disableScroll() {
  window.addEventListener('DOMMouseScroll', preventDefault, false)
  window.addEventListener(wheelEvent, preventDefault, wheelOpt)
  window.addEventListener('touchmove', preventDefault, wheelOpt)
  window.addEventListener('keydown', preventDefaultForScrollKeys, false)
}

function enableScroll() {
  window.removeEventListener('DOMMouseScroll', preventDefault, false)
  window.removeEventListener(wheelEvent, preventDefault, wheelOpt)
  window.removeEventListener('touchmove', preventDefault, wheelOpt)
  window.removeEventListener('keydown', preventDefaultForScrollKeys, false)
}

// End Section 8 specific scripts

window.addEventListener('load', () => {

    // Section 8 - Modal | Dialog Control
    const modal = document.querySelector("#de-brandMission-modal")
    const openModal = document.querySelector(".de-brandMission-open-button")
    const closeModal = document.querySelector("#de-brandMission-close")
    const video = document.querySelector(".de-brandMission-video")

    // Dialog Polyfill
    if (modal) {

      dialogPolyfill.registerDialog(modal)

      openModal.addEventListener("click", () => {
        modal.showModal()
        disableScroll()
      })

      closeModal.addEventListener("click", () => {
        video.pause()
        modal.close()
        enableScroll()
      })

      modal.addEventListener("click", (event) => {
          var rect = modal.getBoundingClientRect();
          var isInDialog=(rect.top <= event.clientY && event.clientY <= rect.top + rect.height
            && rect.left <= event.clientX && event.clientX <= rect.left + rect.width);
          if (!isInDialog) {
              video.pause()
              modal.close()
              enableScroll()
            }
      })

    }

    // End Section 8 specific scripts

    const section1MobContainer = document.querySelector(
        '.de-section1Container-mobile'
    );
    const section1DeskContainer = document.querySelector(
        '.de-section1Container-desktop'
    );
    const section2MobContainer = document.querySelector(
        '.de-section2Container-mobile'
    );
    const section2DeskContainer = document.querySelector(
        '.de-section2Container-desktop'
    );
    const section3MobContainer = document.querySelector(
        '.de-Section3Mob-outer-container'
    );
    const section3DeskContainer = document.querySelector(
        '.de-Section3Des-outer-container'
    );
    const section4MobContainer = document.querySelector(
        '.de-Section4Mob-outer-container'
    );
    const section4DeskContainer = document.querySelector(
        '.de-Section4Des-outer-container'
    );
    const section5Container = document.querySelector(
        '.de-section5Container'
    );
    const section6MobContainer = document.querySelector(
        '.de-Section6Mob-outer-container'
    );
    const section6DeskContainer = document.querySelector(
        '.de-Section6Des-outer-container'
    );
    const section7Container = document.querySelector(
        '.de-section7Container'
    );
    const section13Container = document.querySelector(
        '.de-section13Container'
    );

    const section14MobContainer = document.querySelector(
      '.de-Section14Mob-outer-container'
    );
    const section14DeskContainer = document.querySelector(
      '.de-Section14Des-outer-container'
    );
    const sectionHeroProdStoriesMobContainer = document.querySelector(
      '.de-SectionHeroProdStoriesMob-outer-container'
    );
    const sectionHeroProdStoriesDesContainer = document.querySelector(
      '.de-SectionHeroProdStories-outer-container'
    );

    const section8Container = document.querySelector(
        '.de-brandMission-section'
    );

    let section1MobContainerTracked = false;
    let section1DeskContainerTracked = false;
    let section2MobContainerTracked = false;
    let section2DeskContainerTracked = false;
    let section3MobContainerTracked = false;
    let section3DeskContainerTracked = false;
    let section4MobContainerTracked = false;
    let section4DeskContainerTracked = false;
    let section5ContainerTracked = false;
    let section6MobContainerTracked = false;
    let section6DeskContainerTracked = false;
    let section7ContainerTracked = false;
    let section13ContainerTracked = false;
    let section14MobContainerTracked = false;
    let section14DeskContainerTracked = false;
    let sectionHeroProdStoriesMobContainerTracked = false;
    let sectionHeroProdStoriesDesContainerTracked = false;
    let section8ContainerTracked = false;

    const firePageViewEvent = () => {
      // Small Screen Size
      if ($(window).width() < 640) {
        if (section1MobContainer) {
          if (
            isScrolledIntoView(section1MobContainer) &&
            !section1MobContainerTracked
          ) {
            // Use the custom GTM `pageview` event trigger
              window.dataLayer = window.dataLayer || [];
              window.dataLayer.push({
              event: 'pageview',
              category: 'Home Page',
              action: 'View',
              label: `Campaign`
            });
            section1MobContainerTracked = true;
          }
        }
        if (section2MobContainer) {
          if (
            isScrolledIntoView(section2MobContainer) &&
            !section2MobContainerTracked
          ) {
            // Use the custom GTM `pageview` event trigger
              window.dataLayer = window.dataLayer || [];
              window.dataLayer.push({
              event: 'pageview',
              category: 'Home Page',
              action: 'View',
              label: `Encourage Sign In`
            });
            section2MobContainerTracked = true;
          }
        }
        if (section3MobContainer) {
          if (
            isScrolledIntoView(section3MobContainer) &&
            !section3MobContainerTracked
          ) {
            // Use the custom GTM `pageview` event trigger
              window.dataLayer = window.dataLayer || [];
              window.dataLayer.push({
              event: 'pageview',
              category: 'Home Page',
              action: 'View',
              label: `Department Collection List`
            });
            section3MobContainerTracked = true;
          }
        }
        if (section4MobContainer) {
          if (
            isScrolledIntoView(section4MobContainer) &&
            !section4MobContainerTracked
          ) {
            // Use the custom GTM `pageview` event trigger
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
              event: 'pageview',
              category: 'Home Page',
              action: 'View',
              label: `Category`
            });
            section4MobContainerTracked = true;
          }
        }
        if (section6MobContainer) {
          if (
            isScrolledIntoView(section6MobContainer) &&
            !section6MobContainerTracked
          ) {
            // Use the custom GTM `pageview` event trigger
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
              event: 'pageview',
              category: 'Home Page',
              action: 'View',
              label: `Hero Product`
            });
            section6MobContainerTracked = true;
          }
        }
        if (section14MobContainer) {
          if (
            isScrolledIntoView(section14MobContainer) &&
            !section14MobContainerTracked
          ) {
            // Use the custom GTM `pageview` event trigger
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
              event: 'pageview',
              category: 'Home Page',
              action: 'View',
              label: `Our Mission`
            });
            section14MobContainerTracked = true;
          }
        }
        if (sectionHeroProdStoriesMobContainer) {
          if (
            isScrolledIntoView(sectionHeroProdStoriesMobContainer) &&
            !sectionHeroProdStoriesMobContainerTracked
          ) {
            // Use the custom GTM `pageview` event trigger
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
              event: 'pageview',
              category: 'Home Page',
              action: 'View',
              label: `Hero stories`
            });
            sectionHeroProdStoriesMobContainerTracked = true;
          }
        }
        // Medium, Large, and X-Large Screen Sizes
        } else {

            if (section1DeskContainer) {
                if (
                    isScrolledIntoView(section1DeskContainer) &&
                    !section1DeskContainerTracked
                ) {
                    // Use the custom GTM `pageview` event trigger
                    window.dataLayer = window.dataLayer || [];
                    window.dataLayer.push({
                        event: 'pageview',
                        category: 'Home Page',
                        action: 'View',
                        label: `Campaign`
                    });
                    section1DeskContainerTracked = true;
                }
            }

            if (section2DeskContainer) {
                if (
                    isScrolledIntoView(section2DeskContainer) &&
                    !section2DeskContainerTracked
                ) {
                // Use the custom GTM `pageview` event trigger
                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push({
                  event: 'pageview',
                  category: 'Home Page',
                  action: 'View',
                  label: `Encourage Sign In`
                });
                section2DeskContainerTracked = true;
                }
            }

            if (section3DeskContainer) {
                if (
                  isScrolledIntoView(section3DeskContainer) &&
                  !section3DeskContainerTracked
                ) {
                // Use the custom GTM `pageview` event trigger
                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push({
                  event: 'pageview',
                  category: 'Home Page',
                  action: 'View',
                  label: `Department Collection List`
                });
                section3DeskContainerTracked = true;
              }
            }
            if (section4DeskContainer) {
              if (
                  isScrolledIntoView(section4DeskContainer) &&
                  !section4DeskContainerTracked
              ) {
              // Use the custom GTM `pageview` event trigger
              window.dataLayer = window.dataLayer || [];
              window.dataLayer.push({
                event: 'pageview',
                category: 'Home Page',
                action: 'View',
                label: `Category`
              });
              section4DeskContainerTracked = true;
              }
            }
          if (section6DeskContainer) {
            if (
              isScrolledIntoView(section6DeskContainer) &&
              !section6DeskContainerTracked
            ) {
            // Use the custom GTM `pageview` event trigger
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
              event: 'pageview',
              category: 'Home Page',
              action: 'View',
              label: `Hero Product`
            });
            section6DeskContainerTracked = true;
            }
          }
          if (section14DeskContainer) {
            if (
              isScrolledIntoView(section14DeskContainer) &&
              !section14DeskContainerTracked
            ) {
            // Use the custom GTM `pageview` event trigger
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
              event: 'pageview',
              category: 'Home Page',
              action: 'View',
              label: `Our Mission`
            });
            section14DeskContainerTracked = true;
            }
          }
          if (sectionHeroProdStoriesDesContainer) {
            if (
              isScrolledIntoView(sectionHeroProdStoriesDesContainer) &&
              !sectionHeroProdStoriesDesContainerTracked
            ) {
            // Use the custom GTM `pageview` event trigger
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
              event: 'pageview',
              category: 'Home Page',
              action: 'View',
              label: `Hero stories`
            });
            sectionHeroProdStoriesDesContainerTracked = true;
            }
          }
        }

        if (section5Container) {
            if (
                isScrolledIntoView(section5Container) &&
                !section5ContainerTracked
            ) {
            // Use the custom GTM `pageview` event trigger
                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push({
                    event: 'pageview',
                    category: 'Home Page',
                    action: 'View',
                    label: `Sneak Peak Carousel`
                });
                section5ContainerTracked = true;
            }
        }

        if (section7Container) {
            if (
                isScrolledIntoView(section7Container) &&
                !section7ContainerTracked
            ) {
                // Use the custom GTM `pageview` event trigger
                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push({
                    event: 'pageview',
                    category: 'Home Page',
                    action: 'View',
                    label: `Value Proposition`
                });
                section7ContainerTracked = true;
            }
        }

        if (section13Container) {
            if (
                isScrolledIntoView(section13Container) &&
                !section13ContainerTracked
            ) {
                // Use the custom GTM `pageview` event trigger
                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push({
                    event: 'pageview',
                    category: 'Home Page',
                    action: 'View',
                    label: `Shop All Sports`
                });
                section13ContainerTracked = true;
            }
        }

        if (section8Container) {
            if (
                isScrolledIntoView(section8Container) &&
                !section8ContainerTracked
            ) {
            // Use the custom GTM `pageview` event trigger
                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push({
                    event: 'pageview',
                    category: 'Home Page',
                    action: 'View',
                    label: `Brand Mission Statement`
                });
                section8ContainerTracked = true;
            }
        }

      };

    firePageViewEvent();

    window.addEventListener('scroll', (event) => {
        firePageViewEvent();
    });

});

/* Section 14 video play functionality */

$('.js-bannerVideo').on('click', function(event) {

  $(this).addClass('play-button-hidden');
  $('.banner--video').addClass('zero-height-during-play');

  if($(window).width() >= 640){
    $('.banner--video').attr('style','background-color:#f3f3f3');
    $('.banner--video').attr('style','background-color:transparent !important');
  }

});

$('.banner--video').on('click', function(event) {
  event.preventDefault();
  const n = $(this);

  if ($('.banner--video #bannerVideo').length){
      $('.banner--video #bannerVideo').remove();
      const linkEl = $('.banner--video .js-bannerVideo');
      const o = linkEl
        .attr('href')
        .replace('https://www.youtube.com/watch?v=', '');
      n.append(
        `<div id="bannerVideoSec4-2"><div class="js-closeBannerVideo"></div><div class="embedWrapper"><div class="embedContainer"><iframe src="https://www.youtube.com/embed/${o}?autoplay=1&rel=0" frameborder="0" allowfullscreen></iframe></div></div></div>`
      );
      if (linkEl.attr('data-videoButton')) {
        const a = JSON.parse(linkEl.attr('data-videoButton'));
        $('#bannerVideoSec4-2').append(
          `<p class="bannerButton"><a class="btn" href="${a.url}">${a.text}</a></p>`
        );
      }
      $('#bannerVideoSec4-2').addClass('video-container-full-width');
      n.addClass('banner--videoActive');
      linkEl.addClass('play-button-hidden');
      n.addClass('zero-height-during-play');

      if($(window).width() < 640){
        n.attr('style','background-color:#f3f3f3');
      }else{
        n.attr('style','background-color:#f3f3f3');
        n.attr('style','background-color:transparent !important');
      }

      $('.js-closeBannerVideo').click(() => {
        n.removeClass('banner--videoActive');
        if ($(global).width() >= breakpoint) $('#bannerVideoSec4-2').remove();
        else
          setTimeout(() => {
            $('#bannerVideoSec4-2').remove();
          }, 750);
      });

  }else{
    const linkEl = $('.banner--video .js-bannerVideo');
    const o = linkEl
      .attr('href')
      .replace('https://www.youtube.com/watch?v=', '');
    n.append(
      `<div id="bannerVideoSec4-2"><div class="js-closeBannerVideo"></div><div class="embedWrapper"><div class="embedContainer"><iframe src="https://www.youtube.com/embed/${o}?autoplay=1&rel=0" frameborder="0" allowfullscreen></iframe></div></div></div>`
    );
    if (linkEl.attr('data-videoButton')) {
      const a = JSON.parse(linkEl.attr('data-videoButton'));
      $('#bannerVideoSec4-2').append(
        `<p class="bannerButton"><a class="btn" href="${a.url}">${a.text}</a></p>`
      );
    }
    $('#bannerVideoSec4-2').addClass('video-container-full-width');
    n.addClass('banner--videoActive');
    linkEl.addClass('play-button-hidden');
    n.addClass('zero-height-during-play');

    if($(window).width() < 640){
      n.attr('style','background-color:#f3f3f3');
    }else{
      n.attr('style','background-color:#f3f3f3');
      n.attr('style','background-color:transparent !important');
    }

    $('.js-closeBannerVideo').click(() => {
      n.removeClass('banner--videoActive');
      if ($(global).width() >= breakpoint) $('#bannerVideoSec4-2').remove();
      else
        setTimeout(() => {
          $('#bannerVideoSec4-2').remove();
        }, 750);
    });

  }

});
